const swiper08 = new Swiper('.content-wrapper-responsive', {
    direction: 'horizontal',
    spaceBetween: 15,
    slidesPerView: 1.2,
    breakpoints: {
          769:{
              slidesPerView: 3,
          },
          426:{
              slidesPerView: 2.3,
          }
      }
})